(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6652],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 62911:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/contact",
      function () {
        return __webpack_require__(5901);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ getOtpAnalytics; },
/* harmony export */   "F$": function() { return /* binding */ serviceRequestOrFeedbackAnalytics; },
/* harmony export */   "M2": function() { return /* binding */ breadcrumbAnalytics; },
/* harmony export */   "XI": function() { return /* binding */ cancelAnalytics; },
/* harmony export */   "jB": function() { return /* binding */ cancelFeedbackAnalytics; },
/* harmony export */   "qi": function() { return /* binding */ submitAnalytics; },
/* harmony export */   "qz": function() { return /* binding */ submitFeedbackAnalytics; },
/* harmony export */   "xl": function() { return /* binding */ backToCustomerSupportAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const pageType = "contact";
const breadcrumbAnalytics = async (navItem)=>{
    const url = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getShortenedUrl)(navItem === null || navItem === void 0 ? void 0 : navItem.url);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:hero banner:breadcrumb",
        eventName: "support:contact:hero banner:breadcrumb",
        eventType: "navigation",
        internalLinkName: "home > customer support",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:breadcrumb",
        internalLinkZoneName: "support:contact:hero banner",
        internalLinkURL: window.location.origin + url
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getOtpAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:get otp",
        eventName: "support:contact:form:get otp",
        eventType: "navigation",
        internalLinkName: "get otp",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const serviceRequestOrFeedbackAnalytics = (activeTab)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:".concat(activeTab.toLowerCase()),
        eventName: "support:contact:form:".concat(activeTab.toLowerCase()),
        eventType: "navigation",
        internalLinkName: activeTab.toLowerCase(),
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const submitAnalytics = (param)=>{
    let { status , serviceRequest ="" , productDetails ="" , statusMsg =null  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:service request:submit",
        eventName: "support:contact:form:service request:submit",
        eventStatus: status,
        eventMsg: statusMsg !== null && statusMsg !== void 0 ? statusMsg : "n/a",
        eventType: "navigation",
        internalLinkName: "submit",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support:service request",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a",
        serviceRequest: serviceRequest === null || serviceRequest === void 0 ? void 0 : serviceRequest.toLowerCase(),
        productDetails: productDetails === null || productDetails === void 0 ? void 0 : productDetails.toLowerCase()
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const cancelAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:service request:cancel",
        eventName: "support:contact:form:service request:cancel",
        eventType: "navigation",
        internalLinkName: "cancel",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support:service request",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const backToCustomerSupportAnalytics = (tab)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:".concat(tab, ":back to customer support"),
        eventName: "support:contact:form:".concat(tab, ":back to customer support"),
        eventType: "navigation",
        internalLinkName: "back to customer support",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support:".concat(tab),
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const submitFeedbackAnalytics = (status, rating, option)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:feedback:submit",
        eventName: "support:contact:form:feedback:submit",
        eventStatus: status,
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "submit",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support:feedback",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a",
        selectRating: rating,
        selectOption: option
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const cancelFeedbackAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:feedback:cancel",
        eventName: "support:contact:form:feedback:cancel",
        eventType: "navigation",
        internalLinkName: "cancel",
        internalLinkPosition: pageType,
        internalLinkType: "support:contact:service & support:feedback",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};


/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={} , analyticsEvent , analyticsData  } = props;
    const isHomePage = (url)=>{
        return !url || url === _constants_index__WEBPACK_IMPORTED_MODULE_5__.HOMEPAGEURL ? "/" : url;
    };
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url));
        setShortURLs(urls);
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).map((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        let path = "";
        for(let i = 0; i < index; i++){
            var ref;
            path += "".concat((ref = items[i].title) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ");
        }
        if (!isSsr) {
            var ref1;
            let eventInfo = {
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: path + (navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                internalLinkPosition: eventPageName,
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url) : "n/a",
                internalLinkZoneName: eventPageName + ":" + zone
            };
            if (analyticsData) {
                eventInfo = {
                    ...eventInfo,
                    ...analyticsData
                };
            }
            return JSON.stringify(eventInfo);
        }
    };
    const handleClick = (navItem)=>{
        if (analyticsEvent) {
            analyticsEvent(navItem);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
        children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            id: "breadcrumb",
            className: "cmp-breadcrumb",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "cmp-breadcrumb__list",
                itemScope: true,
                itemType: ITEM_TYPE.breadcrumbList,
                children: items.map((navItem, index)=>{
                    const isLastItem = index === items.length - 1;
                    const isActive = navItem.active;
                    const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "cmp-breadcrumb__item",
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: ITEM_TYPE.listItem,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isHomePage(shortURLs[index]),
                                className: "cmp-breadcrumb__item-link",
                                itemProp: "item",
                                "data-zone": zone,
                                "aria-label": navItem.title,
                                "aria-current": navItem.active ? "page" : null,
                                "data-gbh-data-layer": !analyticsEvent && !isSsr ? getEventInfo(navItem, index) : null,
                                onClick: ()=>handleClick(navItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    itemProp: "name",
                                    dangerouslySetInnerHTML: {
                                        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                    }
                                })
                            }),
                            shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cmp-breadcrumb-slash",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                itemProp: "position",
                                content: index + 1
                            })
                        ]
                    }, "breadcrumb-item-".concat(index));
                })
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 5901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; },
  "getServerSideProps": function() { return /* binding */ getServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CustomerSupport/CustomerSupport.view/index.module.scss
var index_module = __webpack_require__(74952);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/CustomerSupport/analytics.js
var analytics = __webpack_require__(86638);
;// CONCATENATED MODULE: ./components/CustomerSupport/FormTabs.jsx



function FormTabs(props) {
    const { activeTab , label , changeActive  } = props;
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 && activeTab === "Feedback") {
            changeActive("Service Request");
            (0,analytics/* serviceRequestOrFeedbackAnalytics */.F$)("service request");
            document.getElementById("Service Request-tab").focus();
        } else if (e.keyCode === 39 && activeTab === "Service Request") {
            changeActive("Feedback");
            (0,analytics/* serviceRequestOrFeedbackAnalytics */.F$)("feedback");
            document.getElementById("Feedback-tab").focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            id: "contactus-tab-list",
            className: "tab-list",
            role: "tablist",
            children: label.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    id: "".concat(item, "-tab"),
                    role: "tab",
                    "aria-selected": activeTab === item,
                    tabIndex: activeTab === item ? 0 : -1,
                    className: classnames_default()({
                        "tab-list-item": true,
                        "tab-list-active": activeTab === item
                    }),
                    onClick: ()=>{
                        changeActive(item);
                    },
                    onKeyDown: (e)=>handleKeyPress(e),
                    children: item
                }, item))
        })
    });
}
/* harmony default export */ var CustomerSupport_FormTabs = (FormTabs);

// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/icons/calendar.svg
var calendar = __webpack_require__(65110);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./components/Shared/Otp/v1/index.jsx + 1 modules
var v1 = __webpack_require__(30834);
// EXTERNAL MODULE: ./public/icons/edit.svg
var edit = __webpack_require__(62617);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/enquiry.js
var enquiry = __webpack_require__(55754);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/CustomerSupport/Form/ContactInfo.jsx



















const ContactInfo = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const [states, setStates] = (0,react.useState)({});
    const [verifyOTP, setVerifyOTP] = (0,react.useState)(false);
    const [changeNumber, setChangeNumber] = (0,react.useState)(false);
    const [stateCityDisabled, setStateCityDisabled] = (0,react.useState)(true);
    const { activeTab , staticText , error , data , setData , setError , serviceRequest , productDetails , onSubmit , resetData , isEnabled , verified , setVerified , setPincodeValid  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [userDetails, setUserDetails] = (0,react.useState)(false);
    const [numberEditable, setNumberEditable] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.pincode) {
            const response = (0,findStore/* getDetailsFromZipCode */.k_)(data === null || data === void 0 ? void 0 : data.pincode);
            response.then((resp)=>{
                const { statusCode , result ={}  } = resp;
                if (statusCode === 200) {
                    var ref;
                    const res = (ref = result === null || result === void 0 ? void 0 : result.data) !== null && ref !== void 0 ? ref : {};
                    setStates(res);
                    setError({
                        ...error,
                        city: null,
                        state: null
                    });
                    setPincodeValid(false);
                    setStateCityDisabled(true);
                } else {
                    setStateCityDisabled(false);
                }
                return {
                    statusCode
                };
            });
        } else {
            setStates({});
        }
    }, [
        data === null || data === void 0 ? void 0 : data.pincode
    ]);
    (0,react.useEffect)(()=>{
        if (states) {
            var ref;
            const state = (ref = states === null || states === void 0 ? void 0 : states.state) !== null && ref !== void 0 ? ref : "";
            var ref1;
            const city = (ref1 = states === null || states === void 0 ? void 0 : states.city) !== null && ref1 !== void 0 ? ref1 : "";
            setData({
                ...data,
                city: city,
                state: state
            });
        }
    }, [
        states
    ]);
    const onInputChange = (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        setData({
            ...data,
            [field[2]]: value === null || value === void 0 ? void 0 : value.replace(/[&%\\]/g, "")
        });
    };
    const onChangePincode = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                pincode: value
            });
        }
    };
    const onChangeCity = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            city: value
        });
    };
    const onChangeState = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            state: value
        });
    };
    const onChangeNumber = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                atlernateNumber: value
            });
        }
    };
    const onNameChange = (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                [field[2]]: value
            });
        }
    };
    const changeDateFormat = (date)=>{
        if (date) {
            const dateVal = moment_default()(date).format("YYYY-MM-DD");
            setData({
                ...data,
                dateInvoice: dateVal
            });
            setError({});
        } else {
            setData({
                ...data,
                dateInvoice: ""
            });
        }
    };
    const handleServiceRequest = (serviceRequest)=>{
        setData({
            ...data,
            serviceRequest
        });
        setError({
            ...error,
            serviceRequest: false
        });
    };
    const handleProductDetails = (productDetails)=>{
        setData({
            ...data,
            productDetails
        });
        setError({
            ...error,
            productDetails: false
        });
    };
    const serviceList = serviceRequest.map((data)=>{
        return data === null || data === void 0 ? void 0 : data.text;
    });
    const productList = productDetails.map((data)=>{
        return data === null || data === void 0 ? void 0 : data.text;
    });
    const isVal = ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.state) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && ((ref3 = data === null || data === void 0 ? void 0 : (ref2 = data.city) === null || ref2 === void 0 ? void 0 : ref2.trim()) === null || ref3 === void 0 ? void 0 : ref3.length) > 0;
    var ref10;
    const isPincodeValid = (0,validate/* validPincode */.cE)((ref10 = data === null || data === void 0 ? void 0 : data.pincode) !== null && ref10 !== void 0 ? ref10 : "") ? true : isVal ? false : true;
    const validateNumber = (text)=>{
        if ((0,validate/* validPhone */.er)(text)) {
            setData({
                ...data,
                phone: {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    error: false,
                    message: ""
                }
            });
        } else {
            var ref;
            setData({
                ...data,
                phone: {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    error: true,
                    message: (ref = staticText === null || staticText === void 0 ? void 0 : staticText.validPhone) !== null && ref !== void 0 ? ref : ""
                }
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.details")) {
            let dataValue = atob(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.details"));
            setData({
                ...data,
                phone: {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    value: dataValue
                }
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (isAuth && user) {
            setVerified(true);
            setVerifyOTP(false);
            localStorage.removeItem("numberAlreadyExists");
            const { login ="" , firstName ="" , lastName ="" , sub  } = user;
            setData({
                ...data,
                phone: {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    value: login,
                    error: false,
                    message: ""
                },
                fname: firstName,
                lname: lastName,
                email: sub
            });
            setNumberEditable(false);
        }
    }, [
        isAuth,
        user
    ]);
    const onChangeNumberMobile = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                phone: {
                    ...data === null || data === void 0 ? void 0 : data.phone,
                    value: value,
                    error: false,
                    message: ""
                }
            });
        }
    };
    const isValidPhone = (0,validate/* validPhone */.er)(data === null || data === void 0 ? void 0 : (ref4 = data.phone) === null || ref4 === void 0 ? void 0 : ref4.value);
    const changeNumberHandler = async ()=>{
        setVerifyOTP(true);
        setChangeNumber(true);
    };
    const verifiedNumber = ()=>{
        setVerified(true);
        setVerifyOTP(false);
        if (!isAuth) setNumberEditable(true);
        else setNumberEditable(false);
    };
    const getOTP = async ()=>{
        var ref;
        let { numberExists , factorId , userId  } = await (0,enquiry/* checkNumberExists */.gU)(data === null || data === void 0 ? void 0 : (ref = data.phone) === null || ref === void 0 ? void 0 : ref.value);
        const isBrandOrTransact = (0,utils/* isBrandTransact */.AY)();
        if (!isBrandOrTransact && numberExists && !isAuth) {
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            if (isValidPhone) {
                setUserDetails({
                    factorId: factorId,
                    userId: userId
                });
                setVerifyOTP(true);
                setChangeNumber(false);
            } else setVerifyOTP(false);
        }
        (0,analytics/* getOtpAnalytics */.D2)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mb-40",
        children: [
            activeTab === "Service Request" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-0 flex-mobile",
                        children: [
                            !verified && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "country-code",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    disabled: true,
                                    customClass: "customer-support-country-code-input",
                                    id: "contact-user-country-code",
                                    type: "text",
                                    value: data === null || data === void 0 ? void 0 : data.countryCode
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: !verified ? "phone-number" : "phone-number edit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    disabled: verified,
                                    customClass: "customer-support-inputfield",
                                    id: "contact-user-phone",
                                    type: "text",
                                    value: verified ? "+91 ".concat(data === null || data === void 0 ? void 0 : (ref5 = data.phone) === null || ref5 === void 0 ? void 0 : ref5.value) : data === null || data === void 0 ? void 0 : (ref6 = data.phone) === null || ref6 === void 0 ? void 0 : ref6.value,
                                    maxLength: 10,
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobile,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.mobile,
                                    onChange: onChangeNumberMobile,
                                    onInput: onChangeNumberMobile,
                                    autoFocus: true,
                                    showError: data === null || data === void 0 ? void 0 : (ref7 = data.phone) === null || ref7 === void 0 ? void 0 : ref7.error,
                                    errorMessage: data === null || data === void 0 ? void 0 : (ref8 = data.phone) === null || ref8 === void 0 ? void 0 : ref8.message,
                                    onBlur: ()=>{
                                        var ref;
                                        return validateNumber(data === null || data === void 0 ? void 0 : (ref = data.phone) === null || ref === void 0 ? void 0 : ref.value);
                                    },
                                    suffix: verified && numberEditable && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: edit/* default */.Z === null || edit/* default */.Z === void 0 ? void 0 : edit/* default.src */.Z.src,
                                        alt: "",
                                        "aria-hidden": "true",
                                        onClick: changeNumberHandler,
                                        style: {
                                            cursor: "pointer"
                                        }
                                    })
                                })
                            }),
                            !verified && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otp-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "".concat(isValidPhone && "--active"),
                                    tabIndex: 0,
                                    onClick: getOTP,
                                    children: "Get OTP"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat(!verified && isValidPhone ? "mobile-verified-text --error" : "mobile-verified-text"),
                        children: verified ? staticText === null || staticText === void 0 ? void 0 : staticText.mobileVerified : staticText === null || staticText === void 0 ? void 0 : staticText.verifyMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mx-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(lib/* isMobile */.tq ? "pr-0" : "pr-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "contact-user-fname",
                                    type: "text",
                                    customClass: "customer-support-inputfield",
                                    value: data.fname,
                                    maxLength: 40,
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.fname,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.fname,
                                    onChange: onNameChange,
                                    onInput: onNameChange,
                                    showError: error.fname,
                                    errorMessage: error.fname,
                                    onBlur: ()=>props.onBlur("fname")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(lib/* isMobile */.tq ? "pl-0" : "pl-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "contact-user-lname",
                                    type: "text",
                                    customClass: "customer-support-inputfield",
                                    value: data.lname,
                                    maxLength: 40,
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.lname,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.lname,
                                    onChange: onNameChange,
                                    onInput: onNameChange,
                                    showError: error.lname,
                                    errorMessage: error.lname,
                                    onBlur: ()=>props.onBlur("lname")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-email",
                                type: "text",
                                value: data.email,
                                maxLength: 60,
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/email.svg",
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                                onChange: onInputChange,
                                onInput: onInputChange,
                                showError: error.email,
                                errorMessage: error.email,
                                onBlur: ()=>props.onBlur("email")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-address",
                                type: "text",
                                maxLength: 100,
                                value: data.address,
                                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.address,
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.address,
                                onChange: onInputChange,
                                onInput: onInputChange,
                                showError: error.address,
                                errorMessage: error.address,
                                onBlur: ()=>props.onBlur("address"),
                                autoComplete: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-landmark",
                                type: "text",
                                maxLength: 50,
                                value: data.landmark,
                                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.landmark,
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.landmark,
                                onChange: onInputChange,
                                onInput: onInputChange,
                                onBlur: ()=>props.onBlur("landmark")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mx-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(lib/* isMobile */.tq ? "pr-0" : "pr-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    customClass: "customer-support-inputfield",
                                    id: "contact-user-pincode",
                                    type: "text",
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.pincode,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.pincode,
                                    value: data.pincode,
                                    maxLength: 6,
                                    autoComplete: true,
                                    onChange: onChangePincode,
                                    onInput: onChangePincode,
                                    showError: error.pincode,
                                    errorMessage: error.pincode,
                                    onBlur: ()=>props.onBlur("pincode")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(lib/* isMobile */.tq ? "pl-0" : "pl-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    customClass: "customer-support-inputfield",
                                    id: "contact-user-state",
                                    type: "text",
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.state,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.state,
                                    value: data.state,
                                    showError: error.state,
                                    errorMessage: error.state,
                                    onChange: onChangeState,
                                    onInput: onChangeState,
                                    disabled: stateCityDisabled,
                                    onBlur: ()=>props.onBlur("state")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mx-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(lib/* isMobile */.tq ? "pr-0" : "pr-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    customClass: "customer-support-inputfield",
                                    id: "contact-user-city",
                                    type: "text",
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.city,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.city,
                                    value: data.city,
                                    showError: error.city,
                                    errorMessage: error.city,
                                    onChange: onChangeCity,
                                    onInput: onChangeCity,
                                    disabled: stateCityDisabled,
                                    onBlur: ()=>props.onBlur("city")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(lib/* isMobile */.tq ? "pl-0" : "pl-10"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    customClass: "customer-support-inputfield",
                                    id: "contact-user-atlernateNumber",
                                    type: "text",
                                    maxLength: 10,
                                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.alternateNumber,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.alternateNumber,
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/icons/phone-icon.svg",
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    value: data.atlernateNumber,
                                    onChange: onChangeNumber,
                                    onInput: onChangeNumber,
                                    showError: error.atlernateNumber,
                                    errorMessage: error.atlernateNumber,
                                    onBlur: ()=>props.onBlur("atlernateNumber")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row-response",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-response",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "kf-react-datepicker",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                        value: Date.parse(data === null || data === void 0 ? void 0 : data.dateInvoice),
                                        selected: Date.parse(data === null || data === void 0 ? void 0 : data.dateInvoice),
                                        dateFormat: "dd/MM/yyyy",
                                        customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            customClass: "customer-support-inputfield",
                                            id: props === null || props === void 0 ? void 0 : props.id,
                                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: calendar/* default */.Z === null || calendar/* default */.Z === void 0 ? void 0 : calendar/* default.src */.Z.src,
                                                alt: "calendar-icon"
                                            }),
                                            value: props === null || props === void 0 ? void 0 : props.value,
                                            placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.dateOfInvoice),
                                            label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.dateOfInvoice),
                                            showError: error.dateInvoice,
                                            errorMessage: error.dateInvoice,
                                            onChange: props === null || props === void 0 ? void 0 : props.onChange,
                                            onBlur: props === null || props === void 0 ? void 0 : props.onBlur
                                        }),
                                        id: "contact-installed-installDate",
                                        onChange: (date)=>changeDateFormat(date),
                                        minDate: new Date("01/01/2001"),
                                        maxDate: new Date(),
                                        onBlur: ()=>{
                                            return props === null || props === void 0 ? void 0 : props.onBlur("installDate");
                                        },
                                        isClearable: !!(data === null || data === void 0 ? void 0 : data.dateInvoice)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-response",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    id: "contact-installed-serviceRequest",
                                    customClass: "input-field customer-support-inputfield",
                                    data: serviceList,
                                    value: data.serviceRequest,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.serviceRequest,
                                    onChange: (serviceRequest)=>handleServiceRequest(serviceRequest),
                                    showError: error.serviceRequest,
                                    onBlur: ()=>props.onBlur("serviceRequest"),
                                    errorMessage: error.serviceRequest
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0 mb-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                id: "contact-installed-productDetails",
                                customClass: "input-field customer-support-inputfield",
                                data: productList,
                                value: data.productDetails,
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.productDetails,
                                onChange: (productDetails)=>handleProductDetails(productDetails),
                                showError: error.productDetails,
                                onBlur: ()=>props.onBlur("productDetails"),
                                errorMessage: error.productDetails
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-reportIssue",
                                type: "text",
                                maxLength: 250,
                                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.reportIssues,
                                label: staticText === null || staticText === void 0 ? void 0 : staticText.reportIssues,
                                value: data.reportIssue,
                                onChange: onInputChange,
                                onInput: onInputChange,
                                showError: error.reportIssue,
                                errorMessage: error.reportIssue,
                                onBlur: ()=>props.onBlur("reportIssue")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row-response flex-gap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-response",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    customClass: "kf-react-button",
                                    role: "button",
                                    id: "submit-contact-form-button",
                                    onClick: onSubmit,
                                    type: "black",
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.submit,
                                    flexible: true,
                                    disabled: isEnabled
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-response",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    customClass: "kf-react-button",
                                    role: "button",
                                    id: "submit1-contact-form-button",
                                    type: "ghost",
                                    onClick: resetData,
                                    label: staticText === null || staticText === void 0 ? void 0 : staticText.cancel,
                                    flexible: true
                                })
                            })
                        ]
                    })
                ]
            }),
            verifyOTP && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1/* default */.Z, {
                page: "support:contact",
                handleClose: ()=>setVerifyOTP(false),
                showModal: verifyOTP,
                staticTexts: staticText,
                mobile: data === null || data === void 0 ? void 0 : (ref9 = data.phone) === null || ref9 === void 0 ? void 0 : ref9.value,
                userData: data,
                setData: setData,
                verifiedNumber: verifiedNumber,
                changeMobileNumber: changeNumber,
                userDetails: userDetails
            })
        ]
    });
};
/* harmony default export */ var Form_ContactInfo = (ContactInfo);

// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./utils/constants.js
var utils_constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./utils/customerSupport.js




const postCustomerSupport = async (body)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,helper.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await api/* apim.post */.TH.post("".concat(constants.apiBaseUrl).concat(utils_constants/* customerSupportUrl */.MT), body);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getLocationPincode = async (pincode)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = getAccessToken()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await apim.get("".concat(apiBaseUrl).concat(pinCodeUrl, "/").concat(pincode));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const submitFeedback = async (payload)=>{
    var ref;
    let accessToken = null;
    accessToken = (ref = (0,helper.getAccessToken)()) === null || ref === void 0 ? void 0 : ref.token;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await api/* apim.post */.TH.post("".concat(constants.apiBaseUrl).concat(utils_constants/* submitFeedbackUrl */.Wc), payload);
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/CustomerSupport/Confirmation.jsx



const Confirmation = (props)=>{
    const { staticText , resetData  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "customer-support__success-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "customer-support__success-message",
                children: staticText === null || staticText === void 0 ? void 0 : staticText.messageHeaderSuccess
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "customer-support__success-description",
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(staticText === null || staticText === void 0 ? void 0 : staticText.messageDescriptionSuccess)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    customClass: "kf-react-button",
                    className: "kf-react-button button large black flexible",
                    role: "button",
                    id: "submit-contact-form-button",
                    onClick: resetData,
                    type: "black",
                    label: staticText === null || staticText === void 0 ? void 0 : staticText.backToCustomerSupport
                })
            })
        ]
    });
};
/* harmony default export */ var CustomerSupport_Confirmation = (Confirmation);

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
// EXTERNAL MODULE: ./components/core/TextArea/TextArea.jsx
var TextArea = __webpack_require__(29707);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./components/CustomerSupport/Form/index.module.scss
var Form_index_module = __webpack_require__(66924);
var Form_index_module_default = /*#__PURE__*/__webpack_require__.n(Form_index_module);
;// CONCATENATED MODULE: ./components/CustomerSupport/FeedbackFormConfirmation.jsx


const FeedbackFromConfirmation = (props)=>{
    const { staticText , handleResetData , resetTab  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "customer-support-feedback__success-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "customer-support-feedback__success-description",
                children: staticText === null || staticText === void 0 ? void 0 : staticText.feedbackMessageSuccess
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "customer-support-feedback__success-button",
                    role: "button",
                    onClick: ()=>{
                        handleResetData();
                        resetTab();
                    },
                    type: "black",
                    label: staticText === null || staticText === void 0 ? void 0 : staticText.backToCustomerSupport,
                    flexible: true
                })
            })
        ]
    });
};
/* harmony default export */ var FeedbackFormConfirmation = (FeedbackFromConfirmation);

;// CONCATENATED MODULE: ./components/CustomerSupport/Form/FeedbackForm.jsx















const FeedbackForm = (props)=>{
    var ref, ref1, ref2;
    const { staticText , authorData , resetTab  } = props;
    const ratingValues = [
        "1",
        "2",
        "3",
        "4",
        "5"
    ];
    const [errors, setErrors] = (0,react.useState)({});
    const [feedbackFormData, setFeedbackFormData] = (0,react.useState)({});
    const [showReasons, setShowReasons] = (0,react.useState)(false);
    const [success, setSuccess] = (0,react.useState)(false);
    const validateField = (name)=>{
        var ref;
        let value = feedbackFormData[name];
        if (name === "phoneNumber") {
            if (value === "") setErrors({
                ...errors,
                phoneNumber: staticText.errorMobileNumber
            });
            else if (constants.PHONE_REGEX.test(value)) setErrors({
                ...errors,
                phoneNumber: ""
            });
            else setErrors({
                ...errors,
                phoneNumber: staticText.errorValidMobileNumber
            });
        }
        if (name === "requestID") {
            if (value === "" || value === undefined) setErrors({
                ...errors,
                requestID: staticText.errorRequestId
            });
            else setErrors({
                ...errors,
                requestID: ""
            });
        }
        if (name === "rating") {
            if (!(value === null || value === void 0 ? void 0 : value.trim())) setErrors({
                ...errors,
                rating: staticText.errorRating
            });
            else setErrors({
                ...errors,
                rating: ""
            });
        }
        if (name === "technicianOption") {
            if (!(value === null || value === void 0 ? void 0 : value.trim())) setErrors({
                ...errors,
                technicianOption: staticText.errorSelectOption
            });
            else setErrors({
                ...errors,
                technicianOption: ""
            });
        }
        if (name === "otherRatingRemarks" && (feedbackFormData === null || feedbackFormData === void 0 ? void 0 : (ref = feedbackFormData.reasons) === null || ref === void 0 ? void 0 : ref.includes("Others"))) {
            if (value === "") {
                setErrors({
                    ...errors,
                    otherRatingRemarks: staticText.errorComments
                });
            } else setErrors({
                ...errors,
                otherRatingRemarks: ""
            });
        }
    };
    const handleResetData = (isConfirmScreen)=>{
        setFeedbackFormData({});
        setSuccess(false);
        setShowReasons(false);
        scrollToTop();
        isConfirmScreen ? (0,analytics/* backToCustomerSupportAnalytics */.xl)("feedback") : (0,analytics/* cancelFeedbackAnalytics */.jB)();
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        let errorDataList = [];
        setErrors(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.requestID) {
            errorDataList.push("requestID");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.phoneNumber) {
            errorDataList.push("phoneNumber");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.rating) {
            errorDataList.push("rating");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.technicianOption) {
            errorDataList.push("technicianOption");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.otherRatingRemarks) {
            errorDataList.push("otherRatingRemarks");
        }
        errorDataList.map((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { requestID , phoneNumber , rating , reasons , otherCommentRemarks , technicianOption , otherRatingRemarks  } = feedbackFormData;
            const payload = {
                customerRequestId: requestID,
                countryCode: "+91",
                mobile: phoneNumber,
                rating: rating,
                isAgentWearIdCard: technicianOption === "Yes" ? true : false,
                agentComment: otherCommentRemarks,
                feedbackReason: reasons !== null && reasons !== void 0 ? reasons : [],
                feedbackReasonComment: otherRatingRemarks,
                firstName: "",
                lastName: ""
            };
            const response = await submitFeedback(payload);
            if (response.statusCode === 200) {
                setSuccess(true);
                (0,analytics/* submitFeedbackAnalytics */.qz)("success", rating, technicianOption);
                scrollToTop();
                (0,helper.setBannerConfirmationText)(staticText.feedbackBannerConfirmation, "support-form-banner");
            } else {
                setSuccess(false);
                scrollToTop();
            }
        }
    };
    const getErrorList = ()=>{
        const errorList = {
            requestID: validateAllFields("requestID"),
            phoneNumber: validateAllFields("phoneNumber"),
            rating: validateAllFields("rating"),
            technicianOption: validateAllFields("technicianOption"),
            reasons: validateAllFields("reasons"),
            otherRatingRemarks: validateAllFields("otherRatingRemarks")
        };
        return errorList;
    };
    const validateAllFields = (name)=>{
        var ref;
        let value = feedbackFormData[name];
        if (name === "phoneNumber") {
            if (!constants.PHONE_REGEX.test(value)) return staticText.errorMobileNumber;
        }
        if (name === "requestID") {
            if (value === "" || value === undefined) return staticText.errorRequestId;
        }
        if (name === "rating") {
            if (!(value === null || value === void 0 ? void 0 : value.trim())) return staticText.errorRating;
        }
        if (name === "technicianOption") {
            if (!(value === null || value === void 0 ? void 0 : value.trim())) return staticText.errorSelectOption;
        }
        if (name === "reasons" && showReasons) {
            if (value === undefined || !value.length > 0) {
                return staticText.errorSelectReasons;
            }
        }
        if (name === "otherRatingRemarks" && (feedbackFormData === null || feedbackFormData === void 0 ? void 0 : (ref = feedbackFormData.reasons) === null || ref === void 0 ? void 0 : ref.includes("Others"))) {
            if (value === undefined || value === "") {
                return staticText.errorComments;
            }
        }
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) ? true : false;
    const onCheckboxChange = (e, option)=>{
        const { checked  } = e.target;
        if (checked) {
            setFeedbackFormData({
                ...feedbackFormData,
                reasons: [
                    ...(feedbackFormData === null || feedbackFormData === void 0 ? void 0 : feedbackFormData.reasons) || [],
                    option.reasons
                ]
            });
            setErrors({
                ...errors,
                reasons: ""
            });
        } else {
            var ref;
            let updatedReasons = feedbackFormData === null || feedbackFormData === void 0 ? void 0 : (ref = feedbackFormData.reasons) === null || ref === void 0 ? void 0 : ref.filter((ele)=>ele !== option.reasons);
            let error = {
                ...errors
            };
            let feedbackForm = {
                ...feedbackFormData
            };
            feedbackForm = {
                ...feedbackForm,
                reasons: updatedReasons
            };
            if (!updatedReasons.length > 0) error = {
                ...error,
                reasons: staticText.errorSelectReasons
            };
            else error = {
                ...error,
                reasons: ""
            };
            if (option.reasons === "Others") {
                error = {
                    ...error,
                    otherRatingRemarks: ""
                };
                feedbackForm = {
                    ...feedbackForm,
                    otherRatingRemarks: ""
                };
            }
            setFeedbackFormData(feedbackForm);
            setErrors(error);
        }
    };
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const replaceRatingQuestion = (ratingQuestion)=>{
        const cleanText = purify_default().sanitize(ratingQuestion, {
            ALLOWED_TAGS: []
        });
        return cleanText;
    };
    var ref3, _phoneNumber, _rating, _otherRatingRemarks, _technicianOption, _otherCommentRemarks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Form_index_module_default()).customerSupportFeedback,
        children: !success ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "customer-support-feedback__feedback",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "requestID",
                    type: "text",
                    value: (ref3 = feedbackFormData === null || feedbackFormData === void 0 ? void 0 : feedbackFormData.requestID) !== null && ref3 !== void 0 ? ref3 : "",
                    placeholder: staticText.requestID,
                    label: staticText.requestID,
                    onChange: (e)=>{
                        const { value  } = e.target;
                        setFeedbackFormData({
                            ...feedbackFormData,
                            requestID: value
                        });
                    },
                    showError: !errors.requestID || errors.requestID === "" ? false : true,
                    errorMessage: errors.requestID,
                    onBlur: ()=>validateField("requestID"),
                    maxLength: "40"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "customer-support-feedback__phoneDiv",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "customer-support-feedback__countryIcon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                disabled: true,
                                value: "+91"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "customer-support-feedback__phoneNumber",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "phoneNumber",
                                type: "text",
                                value: (_phoneNumber = feedbackFormData.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "",
                                maxLength: 10,
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/phone-icon.svg",
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                placeholder: staticText.registeredNumber,
                                label: staticText.registeredNumber,
                                name: "phoneNumber",
                                onChange: (e)=>{
                                    const { value  } = e.target;
                                    if (value === "" || (0,validate/* validNumber */.BP)(value)) {
                                        setFeedbackFormData({
                                            ...feedbackFormData,
                                            phoneNumber: value
                                        });
                                    }
                                },
                                showError: !errors.phoneNumber || errors.phoneNumber === "" ? false : true,
                                errorMessage: errors.phoneNumber,
                                onBlur: ()=>validateField("phoneNumber")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "customer-support-feedback__ratingQuestionDiv customer-support-feedback__fontText",
                    children: replaceRatingQuestion(staticText === null || staticText === void 0 ? void 0 : staticText.ratingQuestion)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                    label: staticText.selectRating,
                    data: ratingValues,
                    value: (_rating = feedbackFormData.rating) !== null && _rating !== void 0 ? _rating : "",
                    id: "rating",
                    name: "rating",
                    onChange: (e)=>{
                        setFeedbackFormData({
                            ...feedbackFormData,
                            rating: e,
                            reasons: [],
                            otherRatingRemarks: ""
                        });
                        setErrors({
                            ...errors,
                            rating: "",
                            reasons: "",
                            otherRatingRemarks: ""
                        });
                        if (e <= "3") setShowReasons(true);
                        else setShowReasons(false);
                    },
                    showError: !errors.rating || errors.rating === "" ? false : true,
                    errorMessage: errors.rating,
                    onBlur: ()=>validateField("rating"),
                    labelAfterClick: staticText === null || staticText === void 0 ? void 0 : staticText.labelAfterClick
                }),
                showReasons && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "customer-support-feedback__chooseReasonsDiv",
                            children: staticText === null || staticText === void 0 ? void 0 : staticText.selectReasons
                        }),
                        errors.reasons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "customer-support-feedback__errorHeading",
                            children: staticText.errorSelectReasons
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "customer-support-feedback__ratingOptionsMultiple",
                            children: authorData === null || authorData === void 0 ? void 0 : (ref1 = authorData.reasonsMultifield) === null || ref1 === void 0 ? void 0 : ref1.map((option, index)=>{
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "customer-support-feedback__ratingOptions",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        value: option.reasons,
                                        textClassName: "".concat(errors.reasons ? "customer-support-feedback__errorRatingOptions" : ""),
                                        onChange: (e)=>{
                                            onCheckboxChange(e, option);
                                        },
                                        checked: feedbackFormData === null || feedbackFormData === void 0 ? void 0 : (ref = feedbackFormData.reasons) === null || ref === void 0 ? void 0 : ref.includes(option.reasons)
                                    })
                                }, index);
                            })
                        }),
                        (feedbackFormData === null || feedbackFormData === void 0 ? void 0 : (ref2 = feedbackFormData.reasons) === null || ref2 === void 0 ? void 0 : ref2.includes("Others")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                label: staticText.comments,
                                placeholder: staticText.comments,
                                value: (_otherRatingRemarks = feedbackFormData.otherRatingRemarks) !== null && _otherRatingRemarks !== void 0 ? _otherRatingRemarks : "",
                                className: "customer-support-feedback__textarea",
                                maxLength: "250",
                                onChange: (e)=>{
                                    const { value  } = e.target;
                                    setFeedbackFormData({
                                        ...feedbackFormData,
                                        otherRatingRemarks: value
                                    });
                                },
                                id: "otherRatingRemarks",
                                showError: !errors.otherRatingRemarks || errors.otherRatingRemarks === "" ? false : true,
                                errorMessage: errors.otherRatingRemarks,
                                onBlur: ()=>validateField("otherRatingRemarks")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "customer-support-feedback__fontText ".concat(showReasons ? "customer-support-feedback__technicianOption" : "customer-support-feedback__technicianOptionDiv"),
                    children: staticText.technicianFeedbackQuestion
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                    label: staticText.selectOption,
                    data: [
                        "Yes",
                        "No"
                    ],
                    id: "option",
                    name: "technicianOption",
                    value: (_technicianOption = feedbackFormData.technicianOption) !== null && _technicianOption !== void 0 ? _technicianOption : "",
                    onChange: (e)=>{
                        setFeedbackFormData({
                            ...feedbackFormData,
                            technicianOption: e
                        });
                        setErrors({
                            ...errors,
                            technicianOption: ""
                        });
                    },
                    showError: !errors.technicianOption || errors.technicianOption === "" ? false : true,
                    errorMessage: errors.technicianOption,
                    onBlur: ()=>validateField("technicianOption")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "customer-support-feedback__remarksDiv",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                        label: staticText.anyOtherRemarks,
                        placeholder: staticText.anyOtherRemarks,
                        value: (_otherCommentRemarks = feedbackFormData.otherCommentRemarks) !== null && _otherCommentRemarks !== void 0 ? _otherCommentRemarks : "",
                        className: "customer-support-feedback__textarea",
                        maxLength: "250",
                        onChange: (e)=>{
                            const { value  } = e.target;
                            setFeedbackFormData({
                                ...feedbackFormData,
                                otherCommentRemarks: value
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "customer-support-feedback__buttonDiv",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "black",
                            role: "button",
                            label: staticText.submit,
                            className: "customer-support-feedback__button",
                            flexible: true,
                            onClick: ()=>handleSubmit(),
                            disabled: isEnabled
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "customer-support-feedback__button",
                            type: "ghost",
                            role: "button",
                            label: staticText.cancel,
                            flexible: true,
                            onClick: ()=>handleResetData(false)
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackFormConfirmation, {
            handleResetData: ()=>handleResetData(true),
            staticText: staticText,
            resetTab: resetTab
        })
    });
};
/* harmony default export */ var Form_FeedbackForm = (FeedbackForm);

;// CONCATENATED MODULE: ./components/CustomerSupport/CustomerSupport.view/index.jsx














const CustomerSupportView = (props)=>{
    var ref;
    const { activeTab , setActiveTab , staticText , tabTypes , serviceRequest , productDetails , authorData  } = props;
    const { user , isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const initFormData = {
        fname: "",
        lname: "",
        email: "",
        address: "",
        landmark: "",
        pincode: "",
        state: "",
        city: "",
        phone: {
            value: "",
            error: false,
            message: ""
        },
        countryCode: "+91",
        atlernateNumber: "",
        dateInvoice: "",
        serviceRequest: "",
        productDetails: "",
        reportIssue: ""
    };
    const [userData, setUserData] = (0,react.useState)(initFormData);
    const [error, setError] = (0,react.useState)({});
    const [loading, setLoading] = (0,react.useState)(false);
    const [verified, setVerified] = (0,react.useState)(false);
    const [success, setSuccess] = (0,react.useState)(false);
    const [pincodeValid, setPincodeValid] = (0,react.useState)(false);
    const [initialBannerText, setInitialBannerText] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const validSession = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.details")) && (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.verify")) && ((ref = atob(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.verify"))) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = atob(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("okt.user.temp.details"))) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? true : false;
        setVerified(validSession);
    }, []);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const banner = document === null || document === void 0 ? void 0 : document.getElementById("support-form-banner");
        const bannerDesc = (ref = banner === null || banner === void 0 ? void 0 : banner.getElementsByClassName("cmp-teaser__description")) === null || ref === void 0 ? void 0 : ref[0];
        const bannerDescElem = (ref1 = bannerDesc === null || bannerDesc === void 0 ? void 0 : bannerDesc.getElementsByTagName("p")) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (bannerDescElem) {
            setInitialBannerText(bannerDescElem.innerText);
        }
    }, []);
    (0,react.useEffect)(()=>{
        setSuccess(false);
        setVerified(false);
        setError({});
        setUserData(initFormData);
        if (initialBannerText) {
            (0,helper.setBannerConfirmationText)(initialBannerText, "support-form-banner");
        }
    }, [
        activeTab
    ]);
    const validateExist = (field)=>{
        switch(field){
            case "fname":
            case "lname":
                var ref;
                if (!((ref = userData[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", userData[field])) {
                    return field === "fname" ? staticText === null || staticText === void 0 ? void 0 : staticText.fnameError : staticText === null || staticText === void 0 ? void 0 : staticText.lnameError;
                }
                break;
            case "email":
                if (!userData[field]) return staticText === null || staticText === void 0 ? void 0 : staticText.noEmailError;
                else if (!(0,helper.validateField)("email", userData[field]) || !(0,validate/* validateEmail */.oH)(userData[field])) return staticText === null || staticText === void 0 ? void 0 : staticText.validEmail;
                break;
            case "atlernateNumber":
                var ref1;
                if (!(0,validate/* validPhone */.er)(userData[field]) && ((ref1 = userData[field]) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) return staticText === null || staticText === void 0 ? void 0 : staticText.validPhone;
                break;
            case "address":
                var ref2;
                if (!(userData === null || userData === void 0 ? void 0 : (ref2 = userData.address) === null || ref2 === void 0 ? void 0 : ref2.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.addressError;
                break;
            case "city":
                var ref3;
                if (!(userData === null || userData === void 0 ? void 0 : (ref3 = userData.city) === null || ref3 === void 0 ? void 0 : ref3.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.cityError;
                break;
            case "state":
                var ref4;
                if (!(userData === null || userData === void 0 ? void 0 : (ref4 = userData.state) === null || ref4 === void 0 ? void 0 : ref4.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.stateError;
                break;
            case "pincode":
                var ref5, ref6;
                if (!(userData === null || userData === void 0 ? void 0 : (ref5 = userData.pincode) === null || ref5 === void 0 ? void 0 : ref5.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorPincode;
                else if ((userData === null || userData === void 0 ? void 0 : (ref6 = userData.pincode) === null || ref6 === void 0 ? void 0 : ref6.length) !== 6) return staticText === null || staticText === void 0 ? void 0 : staticText.pincodeValid;
                else if (pincodeValid) return staticText === null || staticText === void 0 ? void 0 : staticText.pincodeNotValid;
                break;
            case "dateInvoice":
                var ref7;
                if (!(userData === null || userData === void 0 ? void 0 : (ref7 = userData.dateInvoice) === null || ref7 === void 0 ? void 0 : ref7.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.cityError;
                break;
            case "serviceRequest":
                var ref8;
                if (!(userData === null || userData === void 0 ? void 0 : (ref8 = userData.serviceRequest) === null || ref8 === void 0 ? void 0 : ref8.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorServiceRequest;
                break;
            case "productDetails":
                var ref9;
                if (!(userData === null || userData === void 0 ? void 0 : (ref9 = userData.productDetails) === null || ref9 === void 0 ? void 0 : ref9.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorProductDetails;
                break;
            case "reportIssue":
                var ref10;
                if (!(userData === null || userData === void 0 ? void 0 : (ref10 = userData.reportIssue) === null || ref10 === void 0 ? void 0 : ref10.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorReportIssue;
                break;
            default:
                return;
        }
    };
    const onBlurError = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const getErrorList = ()=>{
        let errorList = {
            fname: validateExist("fname"),
            lname: validateExist("lname"),
            email: validateExist("email"),
            address: validateExist("address"),
            city: validateExist("city"),
            state: validateExist("state"),
            pincode: validateExist("pincode"),
            reportIssue: validateExist("reportIssue"),
            serviceRequest: validateExist("serviceRequest"),
            productDetails: validateExist("productDetails")
        };
        return errorList;
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) ? true : false;
    const isDisabledCTA = isEnabled ? true : verified ? false : true;
    const onSubmit = ()=>{
        var ref;
        setLoading(true);
        let errorDataList = [];
        const errorList = getErrorList();
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.fname) {
            errorDataList.push("contact-user-fname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.lname) {
            errorDataList.push("contact-user-lname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.address) {
            errorDataList.push("contact-user-address");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.city) {
            errorDataList.push("contact-user-city");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.state) {
            errorDataList.push("contact-user-state");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.pincode) {
            errorDataList.push("contact-user-pincode");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.serviceRequest) {
            errorDataList.push("contact-installed-serviceRequest");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.reportIssue) {
            errorDataList.push("contact-user-productDetails");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.reportIssue) {
            errorDataList.push("contact-user-reportIssue");
        }
        errorDataList.map((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            var ref1;
            const { fname , lname , email , address , landmark , city , state , pincode , phone , countryCode , atlernateNumber , dateInvoice , serviceRequest , productDetails , reportIssue  } = userData;
            let body = {
                firstName: fname === null || fname === void 0 ? void 0 : fname.trim(),
                lastName: lname === null || lname === void 0 ? void 0 : lname.trim(),
                email: email,
                addressLine1: address,
                landmark: landmark,
                countryCode: "+91",
                state: state,
                city: city,
                pincode: pincode,
                mobile: phone === null || phone === void 0 ? void 0 : phone.value,
                atlernateNumber: atlernateNumber,
                dateOfInvoice: dateInvoice ? (ref1 = moment_default()(dateInvoice)) === null || ref1 === void 0 ? void 0 : ref1.format("DD/MM/YYYY") : "",
                serviceRequest: serviceRequest,
                productDetail: productDetails,
                reportIssue: reportIssue
            };
            if (isAuth) {
                var ref2;
                body["userId"] = (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : null;
            }
            (0,helper.sanitizeObject)(body);
            postCustomerSupport(body).then((resp)=>{
                const { statusCode , result ={}  } = resp;
                if (statusCode === 200) {
                    (0,analytics/* submitAnalytics */.qi)({
                        status: "success",
                        serviceRequest,
                        productDetails
                    });
                    const res = result.data;
                    (0,helper.setBannerConfirmationText)(staticText.bannerConfirmationText, "support-form-banner");
                    setSuccess(true);
                    scrollToTop();
                    setLoading(false);
                }
                return {
                    statusCode
                };
            });
        } else {
            (0,analytics/* submitAnalytics */.qi)({
                status: "failure",
                statusMsg: "form submition failed"
            });
            setLoading(false);
            let allErrors = [];
            for(const key in errorList){
                if (errorList[key]) {
                    allErrors.push(errorList[key].toLowerCase());
                }
            }
        }
    };
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const resetData = (isConfirmScreen)=>{
        var ref;
        const firstName = (ref = user === null || user === void 0 ? void 0 : user.firstName) !== null && ref !== void 0 ? ref : "";
        var ref1;
        const lastName = (ref1 = user === null || user === void 0 ? void 0 : user.lastName) !== null && ref1 !== void 0 ? ref1 : "";
        var ref2;
        const email = (ref2 = user === null || user === void 0 ? void 0 : user.sub) !== null && ref2 !== void 0 ? ref2 : "";
        setUserData({
            ...userData,
            fname: firstName,
            lname: lastName,
            email: email,
            address: "",
            landmark: "",
            pincode: "",
            state: "",
            city: "",
            countryCode: "+91",
            atlernateNumber: "",
            dateInvoice: "",
            serviceRequest: "",
            productDetails: "",
            reportIssue: ""
        });
        isConfirmScreen ? (0,analytics/* backToCustomerSupportAnalytics */.xl)("service request") : (0,analytics/* cancelAnalytics */.XI)();
        setError({});
        setSuccess(false);
        scrollToTop();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).customerSupportLanding,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "customer-support",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "customer-support__title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "customer-support__question",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.mainTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "customer-support__required-fields",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.requiredInfoText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupport_FormTabs, {
                        label: tabTypes,
                        activeTab: activeTab,
                        changeActive: (tab)=>{
                            setActiveTab(tab);
                            (0,analytics/* serviceRequestOrFeedbackAnalytics */.F$)(tab);
                            setError({});
                        }
                    }),
                    activeTab === "Feedback" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_FeedbackForm, {
                        staticText: staticText,
                        authorData: authorData,
                        resetTab: ()=>setActiveTab("Service Request")
                    }),
                    activeTab === "Service Request" && (success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupport_Confirmation, {
                        staticText: staticText,
                        resetData: ()=>resetData(true)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ContactInfo, {
                        serviceRequest: serviceRequest,
                        productDetails: productDetails,
                        activeTab: activeTab,
                        staticText: staticText,
                        data: userData,
                        setData: setUserData,
                        verified: verified,
                        setVerified: setVerified,
                        error: error,
                        setError: setError,
                        onBlur: onBlurError,
                        onSubmit: onSubmit,
                        resetData: ()=>resetData(false),
                        isEnabled: isDisabledCTA,
                        setPincodeValid: setPincodeValid
                    }, activeTab))
                ]
            })
        })
    });
};
/* harmony default export */ var CustomerSupport_view = (CustomerSupportView);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useCustomerSupporti18n.js

const useCustomerSupporti18n = (authorData)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, _selectReasons, ref8, ref9, ref10;
    const i18n = {
        verifyMobile: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.mobileDescriptionPlaceHolder) !== null && ref !== void 0 ? ref : t("kf.customerSupport.verifyMobile"),
        mobileVerified: (ref1 = authorData === null || authorData === void 0 ? void 0 : authorData.mobilerNumberOtpDescription) !== null && ref1 !== void 0 ? ref1 : t("kf.customerSupport.mobileVerified"),
        serviceTab: t("kf.customerSupport.label.serviceTab"),
        feedbackTab: t("kf.customerSupport.label.feedbackTab"),
        mainTitle: (ref2 = authorData === null || authorData === void 0 ? void 0 : authorData.mainTabTitle) !== null && ref2 !== void 0 ? ref2 : t("kf.customerSupport.label.mainTitle"),
        mobile: (ref3 = authorData === null || authorData === void 0 ? void 0 : authorData.mobilePlaceholder) !== null && ref3 !== void 0 ? ref3 : t("kf.customerSupport.label.mobile"),
        requiredInfoText: t("kf.customerSupport.label.requiredFields"),
        fname: t("kf.customerSupport.label.fname"),
        lname: t("kf.customerSupport.label.lname"),
        email: t("kf.customerSupport.label.email"),
        cemail: t("kf.customerSupport.label.cemail"),
        address: t("kf.customerSupport.label.address"),
        landmark: t("kf.customerSupport.label.landmark"),
        pincode: t("kf.customerSupport.label.pincode"),
        state: t("kf.customerSupport.label.state"),
        city: t("kf.customerSupport.label.city"),
        alternateNumber: t("kf.customerSupport.label.alternateNumber"),
        dateOfInvoice: t("kf.customerSupport.label.dateOfInvoice"),
        serviceRequest: t("kf.customerSupport.label.serviceRequest"),
        productDetails: t("kf.customerSupport.label.productDetails"),
        reportIssues: t("kf.customerSupport.label.reportIssues"),
        submit: t("kf.customerSupport.label.submit"),
        cancel: t("kf.customerSupport.label.cancel"),
        verify: t("kf.customerSupport.label.verify"),
        backToCustomerSupport: (ref4 = authorData === null || authorData === void 0 ? void 0 : authorData.ctaLabel) !== null && ref4 !== void 0 ? ref4 : t("kf.customerSupport.label.backToCustomerSupport"),
        messageMobile: t("kf.customerSupport.message.mobile"),
        messageHeaderSuccess: (ref5 = authorData === null || authorData === void 0 ? void 0 : authorData.successTitle) !== null && ref5 !== void 0 ? ref5 : t("kf.customerSupport.message.headerSuccess"),
        messageDescriptionSuccess: (ref6 = authorData === null || authorData === void 0 ? void 0 : authorData.successDescription) !== null && ref6 !== void 0 ? ref6 : t("kf.customerSupport.message.descriptionSuccess"),
        messageVerifyPhone: t("kf.customerSupport.message.verifyPhone"),
        errorMobile: t("kf.customerSupport.error.mobile"),
        errorFname: t("kf.customerSupport.error.fname"),
        errorLname: t("kf.customerSupport.error.lname"),
        errorEmail: t("kf.customerSupport.error.email"),
        errorAddress: t("kf.customerSupport.error.address"),
        errorPincode: t("kf.customerSupport.error.pincode"),
        pincodeValid: t("kf.customerSupport.error.pincodeValid"),
        pincodeNotValid: t("kf.customerSupport.error.pincodeNotValid"),
        errorState: t("kf.customerSupport.error.state"),
        errorCity: t("kf.customerSupport.error.city"),
        errorServiceRequest: t("kf.customerSupport.error.serviveRequest"),
        errorProductDetails: t("kf.customerSupport.error.productDetails"),
        errorReportIssue: t("kf.customerSupport.error.reportIssue"),
        fnameError: t("kf.contactus.error.fnameError"),
        lnameError: t("kf.contactus.error.lnameError"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        validEmail: t("kf.contactus.error.validEmail"),
        confirmEmailError: t("kf.contactus.error.confirmEmailError"),
        emailMatchError: t("kf.contactus.error.emailMatchError"),
        noCompanyError: t("kf.contactus.error.noCompanyError"),
        businessTypeError: t("kf.contactus.error.businessTypeError"),
        subTypeError: t("kf.contactus.error.subTypeError"),
        addressError: t("kf.contactus.error.addressError"),
        cityError: t("kf.contactus.error.cityError"),
        stateError: t("kf.contactus.error.stateError"),
        zipcodeError: t("kf.contactus.error.zipcodeError"),
        validZipcode: t("kf.contactus.error.validZipcode"),
        cityStateZipMismatchError: t("kf.contactus.error.cityStateZipMismatchError"),
        countryError: t("kf.contactus.error.countryError"),
        validPhone: t("kf.contactus.error.validPhone"),
        noPhoneError: t("kf.contactus.error.noPhoneError"),
        ratingQuestion: (ref7 = authorData === null || authorData === void 0 ? void 0 : authorData.ratingQuestion) !== null && ref7 !== void 0 ? ref7 : t("kf.customerSupport.ratingQuestion"),
        selectReasons: (_selectReasons = authorData.selectReasons) !== null && _selectReasons !== void 0 ? _selectReasons : t("kf.customerSupport.selectReasons"),
        requestID: t("kf.customerSupport.requestID"),
        registeredNumber: t("kf.customerSupport.registeredNumber"),
        selectRating: t("kf.customerSupport.selectRating"),
        labelAfterClick: t("kf.customerSupport.labelAfterClick"),
        comments: t("kf.customerSupport.comments"),
        technicianFeedbackQuestion: (ref8 = authorData === null || authorData === void 0 ? void 0 : authorData.technicianFeedbackQuestion) !== null && ref8 !== void 0 ? ref8 : t("kf.customerSupport.technicianFeedbackQuestion"),
        selectOption: t("kf.customerSupport.selectOption"),
        anyOtherRemarks: t("kf.customerSupport.anyOtherRemarks"),
        submit: t("kf.contactus.label.submitButton"),
        changeNumber: t("kf.customerSupport.label.changeNumber"),
        errorRequestId: t("kf.customerSupport.error.requestID"),
        errorMobileNumber: t("kf.customerSupport.error.mobileNumber"),
        errorRating: t("kf.customerSupport.error.rating"),
        errorSelectOption: t("kf.customerSupport.error.selectOption"),
        errorSelectReasons: t("kf.customerSupport.error.selectReasons"),
        errorComments: t("kf.customerSupport.error.comments"),
        feedbackMessageSuccess: t("kf.customerSupport.feedbackMessageSuccess"),
        errorValidMobileNumber: t("kf.customerSupport.error.validMobileNumber"),
        bannerConfirmationText: (ref9 = authorData === null || authorData === void 0 ? void 0 : authorData.bannerConfirmationText) !== null && ref9 !== void 0 ? ref9 : "",
        feedbackBannerConfirmation: (ref10 = authorData === null || authorData === void 0 ? void 0 : authorData.feedbackBannerConfirmation) !== null && ref10 !== void 0 ? ref10 : ""
    };
    return i18n;
};
/* harmony default export */ var i18n_useCustomerSupporti18n = (useCustomerSupporti18n);

;// CONCATENATED MODULE: ./components/CustomerSupport/CustomerSupport.jsx




const CustomerSupport = (props)=>{
    const { data: authorData = {} , genericListData  } = props;
    const staticText = i18n_useCustomerSupporti18n(authorData);
    const tabTypes = [
        "Service Request",
        "Feedback"
    ];
    const [activeTab, setActiveTab] = (0,react.useState)(tabTypes[0]);
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupport_view, {
            staticText: staticText,
            activeTab: activeTab,
            setActiveTab: setActiveTab,
            tabTypes: tabTypes,
            serviceRequest: (ref = genericListData === null || genericListData === void 0 ? void 0 : genericListData.serviceRequest) !== null && ref !== void 0 ? ref : [],
            productDetails: (ref1 = genericListData === null || genericListData === void 0 ? void 0 : genericListData.productDetails) !== null && ref1 !== void 0 ? ref1 : [],
            authorData: authorData
        })
    });
};
/* harmony default export */ var CustomerSupport_CustomerSupport = (CustomerSupport);

// EXTERNAL MODULE: ./node_modules/next-i18next/serverSideTranslations.js
var serverSideTranslations = __webpack_require__(55709);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 94 modules
var AemGrid = __webpack_require__(62090);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./page/contact.jsx
















const CustomerSupportPage = (props)=>{
    const { genericListData , tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , datalayerPageName  } = props;
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data === null || data === void 0 ? void 0 : data.title,
                globalScripting: globalScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                        data: data,
                        fullData: fullData,
                        analyticsEvent: analytics/* breadcrumbAnalytics */.M2
                    }),
                landing: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupport_CustomerSupport, {
                        data: data,
                        genericListData: genericListData
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */ async function getServerSideProps(param) {
    let { req , locale  } = param;
    await (esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.reloadResources */.ag.reloadResources());
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    const ip = (0,helper.getClienIP)(req);
    const { data  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: constants.previewContentPrefix + constants.contactUsUrl,
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(constants.contactUsUrl),
        method: "GET"
    });
    const { data: header  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : constants.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.headerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : constants.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.footerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.footerUrl, ".model.json")),
        method: "GET"
    });
    const { data: genericList  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(constants.DEFAULT_CARD_DETAILS_API_PATH),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(constants.DEFAULT_CARD_DETAILS_API_PATH),
        method: "GET"
    });
    const { data: serviceRequest  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(genericList === null || genericList === void 0 ? void 0 : genericList.serviceRequest),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(genericList === null || genericList === void 0 ? void 0 : genericList.serviceRequest),
        method: "GET"
    });
    const { data: productDetails  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(genericList === null || genericList === void 0 ? void 0 : genericList.productDetails),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(genericList === null || genericList === void 0 ? void 0 : genericList.productDetails),
        method: "GET"
    });
    const globalScript = data === null || data === void 0 ? void 0 : data.globalScript;
    const footerScript = data === null || data === void 0 ? void 0 : data.footerScript;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) ? data === null || data === void 0 ? void 0 : data.topHeadScript : null;
    const gbhDataLayerCustom = {};
    if (data === null || data === void 0 ? void 0 : data.datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    }
    if (data === null || data === void 0 ? void 0 : data.eventPageType) {
        gbhDataLayerCustom.eventPageType = data === null || data === void 0 ? void 0 : data.eventPageType;
    }
    let tmpData = {};
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,helper.filterBackEndJson)(tmpData);
    const headertmp = (0,helper.filterBackEndJson)(header);
    const footertmp = (0,helper.filterBackEndJson)(footer);
    const analyticsData = data === null || data === void 0 ? void 0 : data.data;
    const datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    const genericListData = {
        serviceRequest: serviceRequest,
        productDetails: productDetails
    };
    return {
        props: {
            ip,
            genericListData,
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            footerScript,
            topHeadScript,
            analyticsData,
            datalayerPageName,
            gbhDataLayerCustom,
            ...await (0,serverSideTranslations.serverSideTranslations)(locale, [
                "common"
            ])
        }
    };
}
/* harmony default export */ var contact = (CustomerSupportPage);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 74952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerSupportLanding":"CustomerSupport_view_customerSupportLanding__RPBUs"};

/***/ }),

/***/ 66924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerSupportFeedback":"Form_customerSupportFeedback__LZNTn"};

/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,5709,1433,6051,9774,2888,179], function() { return __webpack_exec__(62911); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);